import React, {useRef} from 'react';
import RecommendedCard from "./RecommendedCard";
import Slider from "react-slick";
import Pointer from "../../Components/Pointer";
import "slick-carousel/slick/slick.css";
import "./RecommendedBox_slick.css";
import {useSelector} from "react-redux";
import { Animate } from "react-simple-animate";
import stripHtml from "../../Components/StripHTML";

export default function RecommendedBox() {

    const {
        watchIsActive,
        readIsActive,
        learnIsActive,
        learnOffCanvasIsActive,
        readOffCanvasIsActive,
        watchOffCanvasIsActive,
        faveLearnOffCanvasIsActive,
        faveReadOffCanvasIsActive,
        faveWatchOffCanvasIsActive
    } = useSelector((state) => state.navBar)

    const slider = useRef()

    const settings = {

        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        rows: 3,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    rows: 1,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1040,
                settings: {
                    rows: 1,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    rows: ((learnOffCanvasIsActive || watchOffCanvasIsActive || readOffCanvasIsActive || faveLearnOffCanvasIsActive || faveWatchOffCanvasIsActive || faveReadOffCanvasIsActive) ? 3 : 1),
                    slidesToShow: ((learnOffCanvasIsActive || watchOffCanvasIsActive || readOffCanvasIsActive || faveLearnOffCanvasIsActive || faveWatchOffCanvasIsActive || faveReadOffCanvasIsActive)) ? 1 : 3
                }
            }
        ]

    };

    const getNextSlide = () =>{
        slider.current.slickNext();
    }

    const getPrevSlide = () =>{
        slider.current.slickPrev();
    }

    const { watches } = useSelector((state) => state.watches);
    const { reads } = useSelector((state) => state.reads);
    const { learns } = useSelector((state) => state.learns);

    const latestWatches = [...watches].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 6);
    const latestReads = [...reads].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 6);
    const latestLearns = [...learns].sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 6);

    // console.log("latest watches:", latestWatches);
    // console.log("latest reads:", latestReads);
    // console.log("latest learns:", latestLearns);

    return (<>
        <div className={`recommendedBox  border-3 border-purple-slumber/50 p-4 pb-2 xl-pb-4 w-full h-auto rounded-lg text-white `}>
            <Animate play start={{opacity: 0}} end={{opacity: 1}} duration={0.7}>
            <div className={`3xl:p-3 p-1 pl-0 font-semibold sliderTopGroup flex flex-row items-center xl:flex-col 2xl:flex-row   justify-between text-lg`}>


                    <div className={`flex items-center xl:justify-center mt-2 mb-4 sm:mt-0 sm:mb-0 text-base`}>Recommended For You</div>
                    <div className="arrowGroup hidden sm:flex flex-row gap-2 justify-center my-1">
                        <Pointer direction={"left"} bgColor={"purple-slumber"} task={getPrevSlide}  />
                        <Pointer direction={"right"} bgColor={"purple-slumber"} task={getNextSlide}  />
                    </div>


            </div>
            </Animate>


            {(watchIsActive || faveWatchOffCanvasIsActive) && (
                <Slider ref={(c) => (slider.current = c)} {...settings}>
                    {latestWatches.map((watch, index) => (
                        <RecommendedCard
                            key={index}
                            type={"watch"}
                            imgSrc={watch?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? null}
                            title={stripHtml(watch?.title?.rendered ?? "")}
                            text={watch?.content?.rendered ?? ""}
                            vidLink={watch?.acf?.video_network === "vimeo" ? watch?.acf?.vimeo_url ?? null : watch?.acf?.youtube_url ?? null}
                            mediaType={watch?.type ?? null}
                            mediaId={watch?.id ?? null}
                            orientation={watch?.acf?.orientation ?? null}
                        />
                    ))}
                </Slider>
            )}

            {(readIsActive || faveReadOffCanvasIsActive) && (
                <Slider ref={(c) => (slider.current = c)} {...settings}>
                    {latestReads.map((read, index) => (
                        <RecommendedCard
                            key={index}
                            type={"read"}
                            imgSrc={read?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? null}
                            title={stripHtml(read?.title?.rendered ?? "")}
                            text={read?.content?.rendered ?? ""}
                            date={read?.date ?? null}
                            authorName={read?._embedded?.author?.[0]?.name ?? ""}
                        />
                    ))}
                </Slider>
            )}

            {(learnIsActive || faveLearnOffCanvasIsActive) && (
                <Slider ref={(c) => (slider.current = c)} {...settings}>
                    {latestLearns.map((learn, index) => (
                        <RecommendedCard
                            key={index}
                            type={"learn"}
                            imgSrc={learn?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ?? null}
                            title={stripHtml(learn?.title?.rendered ?? "")}
                            text={learn?.content?.rendered ?? ""}
                            vidLink={learn?.acf?.video_network === "vimeo" ? learn?.acf?.vimeo_url ?? null : learn?.acf?.youtube_url ?? null}
                            mediaType={learn?.type ?? null}
                            mediaId={learn.id ?? null}
                            orientation={learn?.acf?.orientation ?? null}
                        />
                    ))}
                </Slider>
            )}

            <div className="arrowGroup sm:hidden flex flex-row gap-2 justify-center my-1">
                <Pointer direction={"left"} bgColor={"purple-slumber"} task={getPrevSlide}  />
                <Pointer direction={"right"} bgColor={"purple-slumber"} task={getNextSlide}  />
            </div>

        </div>
        </>
    );
}
